export const SECTOR_COUNTRY_MAPPING = "Sector country mapping";

export const DISCLAIMER = "Disclaimer";
